import { gql, useQuery } from '@apollo/client';
import { useToast } from 'components/ui/toast';
import { Query } from 'middleware-types';

const GET_BILLING_CUSTOMER_SUMMARIES = gql`
	query GetBillingCustomerSummaries {
		billingCustomerSummariesGet {
			totalAmountBilled
			totalBalanceDue
			invoiceSummaries {
				organizationName
				organizationHandle
				status
				amountBilled
				balanceDue
				requiresAttention
				stripeCustomerUrl
			}
		}
	}
`;

export const useBillingCustomerSummaries = () => {
	const toast = useToast();
	const { data, loading, error } = useQuery<Pick<Query, 'billingCustomerSummariesGet'>>(
		GET_BILLING_CUSTOMER_SUMMARIES,
		{
			onError: (e) => {
				console.log(e);
				const message =
					e.graphQLErrors?.[0].message ?? 'Unable to load billing customer summaries.';
				toast.push(message, { variant: 'error' });
			},
		}
	);

	const summaries = data?.billingCustomerSummariesGet.invoiceSummaries ?? [];
	const totalAmountBilled = data?.billingCustomerSummariesGet.totalAmountBilled ?? 0;
	const totalBalanceDue = data?.billingCustomerSummariesGet.totalBalanceDue ?? 0;
	return { summaries, totalAmountBilled, totalBalanceDue, loading, error };
};
